"use client";

import Toast from "@/components/design-system/toast";
import { hideAutoOrderToast } from "@/store/autoOrderToastSlice";
import type { AppState } from "@/store/store";
import { useSelector } from "react-redux";

/**
 * Global Auto Order toast renderer. Mounted once at the layout level
 * (`standardPage.tsx`) so any page in the Auto Order migration can dispatch
 * `showAutoOrderToast({...})` without wiring its own toast.
 *
 * Replaces the legacy `window.alert("An unknown error has occurred...")` calls
 * in the windfall-docroot Auto Order code. PI-1372.
 */
const AutoOrderToast = () => {
  const { showToast, toastMessage, toastSubMessage, toastType, persistAcrossNavigation } = useSelector(
    (state: AppState) => state.autoOrderToastSlice,
  );

  return (
    <Toast
      toastMessage={toastMessage}
      toastSubMessage={toastSubMessage}
      showToast={showToast}
      toastType={toastType}
      hideToast={hideAutoOrderToast}
      showCloseButton
      showOnMobile
      showToastTime={5000}
      toastLocation="top"
      persistAcrossNavigation={persistAcrossNavigation}
    />
  );
};

export default AutoOrderToast;
